import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsStepThree = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsStepLeft_1}>TransparenTerra’s</span>
        <span className={styles.toolsStepLeft_2}>Tools</span>
        <span className={styles.toolsStepLeft_3}>and</span>
        <span className={styles.toolsStepLeft_4}>principles</span>
      </div>
    }
    rightContent={
      <div className={styles.toolsStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>Circular economy tools</div>
          TransparenTerra will help transform the devastating linear economy into a sustainable
          circular one. TransparenTerra provides digital solutions for interconnecting and managing
          supply chains in a circular economy.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>A Trustworthy traceability system</div>
          TransparenTerra provides software tools and equipment for supply chain traceability for
          better management, transparency, and accountability.
        </p>
      </div>
    }
  />
);
